import { Manager } from '~/models/manager';

export const managerService = {
	fetch: async (): Promise<Manager.Model | null> => {
		const params = {
			fields: ['*', 'photo.*', 'form.*', 'seo.*'],
		};

		try {
			const response = await $fetch<Manager.Model>(Manager.api, {
				method: 'POST',
				body: { params },
			});

			return response;
		} catch (error) {
			console.error('Failed to fetch Manager:', error);

			return null;
		}
	},
};
